var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnabledLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.85355 2.66598C6.04882 2.86124 6.04882 3.17782 5.85355 3.37308L1.70711 7.51953L15.5 7.51953C15.7761 7.51953 16 7.74339 16 8.01953C16 8.29567 15.7761 8.51953 15.5 8.51953L1.70711 8.51953L5.85355 12.666C6.04882 12.8612 6.04882 13.1778 5.85355 13.3731C5.65829 13.5683 5.34171 13.5683 5.14645 13.3731L0.146447 8.37308C-0.0488155 8.17782 -0.0488155 7.86124 0.146447 7.66598L5.14645 2.66598C5.34171 2.47072 5.65829 2.47072 5.85355 2.66598Z",
    fill: "#051C2C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnabledLeft);
export default __webpack_public_path__ + "static/media/enabled-left.e9c8272884b0aecf09e3fe38d366d0e2.svg";
export { ForwardRef as ReactComponent };